'use client';

import { Box, Flex, Text } from "@chakra-ui/react";
import { dateHoured } from "@/helpers/utils";
import { LuTimer } from "react-icons/lu"

export default function Dated({ dated = new Date() }) {
  return (
     <Box>
        <Flex alignItems="center" color="gray.500">
          <LuTimer size="22" />

          <Box ml="2" lineHeight="1">
            <Text textTransform="uppercase" fontSize="0.7em">
              Postado em:
            </Text>

            <Text fontSize="0.7em">
              { dateHoured(dated) }
            </Text>
          </Box>

        </Flex>
      </Box>
  )
}
